module.exports = __webpack_public_path__ + "img/planito3.71d2402c.png";